// Mutate the page <head> content and <body> script tag
// with information from the next page.

import barba from 'barba'

const head = document.querySelector('head')
const body = document.body
const parser = new DOMParser()
let nextDocument = null



/**
 * Mutations before leave animation
 */
const beforeLeaveMutation = function BeforeLeaveMutation(data) {
    nextDocument = null
    nextDocument = parseNextDocument(data)
    if (nextDocument) {
        appendStyleFrom(nextDocument)
        appendScriptFrom(nextDocument)
    }
}
barba.hooks.beforeLeave(beforeLeaveMutation)



/**
 * Mutations after leave animation
 */
const afterLeaveMutation = function AfterLeaveMutation(data) {

    // If not already defined, retreive the next document
    if (!nextDocument) {
        nextDocument = parseNextDocument(data)
        appendStyleFrom(nextDocument)
        appendScriptFrom(nextDocument)
    }

    // Replace <html lang="...">
    document.documentElement.lang = nextDocument.documentElement.lang

    // Replace <meta>
    const selectorWhitelist = ['meta'].join(',')
    removeFrom(head, selectorWhitelist)
    appendFrom(nextDocument.querySelector('head'), head, selectorWhitelist)

    nextDocument = null
}
barba.hooks.afterLeave(afterLeaveMutation)



/**
 * Parse the next page HTML
 * If succed, return the document node, else null
 */
const parseNextDocument = function ParseNextDocument(data) {
    if (!data.next || !data.next.html) {
        return null
    }
    return parser.parseFromString(data.next.html, "text/html")
}



/**
 * Remove child node who match the whitelist
 */
const removeFrom = function RemoveFrom(fromNode, selectorWhitelist) {
    let child = fromNode.querySelector(selectorWhitelist)
    let count = 0
    while (child && ++count < 999) {
        child.parentNode.removeChild(child)
        child = fromNode.querySelector(selectorWhitelist)
    }
}



/**
 * Append child node from node (fromNode) 
 * to destination (toNode) who match the whitelist
 */
const appendFrom = function AppendFrom(fromNode, toNode, selectorWhitelist) {
    fromNode.querySelectorAll(selectorWhitelist).forEach(node => {
        toNode.appendChild(node)
    })
}



/**
 * Append new style to the <head>
 */
const appendStyleFrom = function AppendStyleFrom(fromNode) {
    // All new style <link> will be inserted before 
    // this node(which are TailwindCSS utilities)
    const referenceNode = head.querySelector('link[rel="stylesheet"][data-chunk="css-utilities.css"]') || null
    // Selector to match (whitelist) <link> to insert
    const selectorWhitelist = 'link[rel="stylesheet"][data-chunk]'

    fromNode.querySelectorAll(selectorWhitelist).forEach(node => {
        if (head.querySelector(`link[rel="stylesheet"][data-chunk="${node.dataset.chunk}"]`)) {
            return
        }
        head.insertBefore(node, referenceNode)
    })
}



/**
 * Append new script to the <body>
 */
const appendScriptFrom = function AppendScriptFrom(fromNode) {
    fromNode.querySelectorAll('script[data-chunk]').forEach(node => {
        if (document.querySelector(`script[data-chunk="${node.dataset.chunk}"]`)) {
            return
        }
        let s = document.createElement('script')
        !node.getAttribute('type') || (s.type = node.getAttribute('type'))
        !node.getAttribute('src') || (s.src = node.getAttribute('src'))
        !node.dataset.chunk || (s.dataset.chunk = node.dataset.chunk)
        body.appendChild(s)
    })
}
